module.exports = __webpack_public_path__ + "static/media/dataarrowleft.c03a37bc.svg";